import { DASHBOARD_COMPONENT_DEFAULT_HEIGHT, DASHBOARD_COMPONENT_DEFAULT_WIDTH, DASHBOARD_GRID_CONFIG } from "../../constants/dashboards/dashboardGridConfig.constant";
import { DashboardComponentData } from "../../types/dashboards/dashboardComponent.type";

export const getInitialPosition = (components: Omit<DashboardComponentData, "dashboard_id" | "data">[]) => {
  if (!components || components.length === 0) return { x: 0, y: 0 };

  const newW = DASHBOARD_COMPONENT_DEFAULT_WIDTH;
  const newH = DASHBOARD_COMPONENT_DEFAULT_HEIGHT;
  const cols = DASHBOARD_GRID_CONFIG.cols?.lg!;

  const maxY = components.reduce((max, c) => Math.max(max, c.start_y + c.height), 0);

  const isOccupied = (x: number, y: number) =>
    components.some(
      (c) => x >= c.start_x && x < c.start_x + c.width && y >= c.start_y && y < c.start_y + c.height
    );

  const fits = (x: number, y: number) => {
    if (x + newW > cols) return false;
    for (let dy = 0; dy < newH; dy++) {
      for (let dx = 0; dx < newW; dx++) {
        if (isOccupied(x + dx, y + dy)) return false;
      }
    }

    return true;
  };

  for (let y = 0; y <= maxY; y++) {
    for (let x = 0; x <= cols - newW; x++) {
      if (fits(x, y)) return { x, y };
    }
  }

  return { x: 0, y: maxY };
}
